<div class="tiime-tooltip" [ngClass]="tooltipClass" [@state]="visibility" (@state.done)="animationDone($event)">
  @if (simpleText?.length) {
    {{ simpleText }}
  } @else {
    <ng-template #outletTemplate [cdkPortalOutlet]="cdkPortal"></ng-template>
  }
</div>
